<form clrForm [formGroup]="dateForm" novalidate>
  <clr-date-container>
    <label>Datum:</label>
    <input clrDate type="date" placeholder="{{ dueDate | date: 'dd.MM.yyyy' }}" formControlName="newDueDate" />
    <span  class="btn-group btn-primary btn-icon"></span>
  </clr-date-container>

  <span  class="btn-group btn-primary btn-icon">
    <button class="btn btn-sm" (click)="updateDueDate()" [disabled]="dateForm.invalid">
    <cds-icon shape="floppy"></cds-icon>
    <span class="clr-icon-title">Speichern</span>
    </button>
  </span>
</form>

<pre *ngIf="devMode" class="datepicker-output">
    {{ dateForm.value | json }}
    dueDate {{ dueDate }}
</pre>
